export default __webpack_public_path__ + "static/media/Salal.b0ff7d43.png";